<!-- 私教合同管理 -->
<template>
    <div class="trainer-contract">
        <el-table
            border
            ref="tableData"
            :data='tableData'
            style="width: 100%"
            @row-click="clickRow"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="35"></el-table-column>
            <el-table-column prop="contractNum" :label="$t('Contract.number')">
                <template slot-scope="{$index, row}">
                    <!-- <a @click="handleShow(row)">{{ row.contractNum }}</a> -->
                    {{ row.contractNum }}
                </template>
            </el-table-column>
            <el-table-column width="70" prop="cardNum" :label="$t('Contract.card_hao')"></el-table-column>
            <el-table-column prop="clientName" :label="$t('Member.name2')">
                <template slot-scope="{row}">
                    <span
                        @click="handleUser(row.clientId)"
                        class="task-workers">
                        {{ row.clientName }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column width="30" prop="clientGender" :label="$t('Common.gender')"></el-table-column>
            <el-table-column prop="clientPhone" :label="$t('Common.telephone_number')" width="110px"></el-table-column>
            <el-table-column prop="lessonName" :label="$t('Course.name')"></el-table-column>
            <el-table-column prop="priceLevel" :label="$t('Member.price_level')"></el-table-column>
            <el-table-column prop="lessonCredit" :label="$t('Member.buy_count')"></el-table-column>
            <el-table-column prop="lessonBalance" :label="$t('Contract.Desc.current_remaining')"></el-table-column>
            <el-table-column prop="type" :label="$t('Contract.type')"></el-table-column>
            <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')">
                <template slot-scope="{row}">
                    <span
                        @click="goDetails(row.originalContractNum)"
                        class="task-workers">
                        {{ row.originalContractNum }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('Contract.status')">
                <template slot-scope="{row}">
                    <span :class="row.status==='有效' ? 'task-status' : 'del-status'">{{ row.status }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="payMethod" :label="$t('Sell.Pay.title')"></el-table-column>
            <el-table-column prop="payableAmt" :label="$t('Charge.amount_receivable')"></el-table-column>
            <el-table-column prop="paidAmt" :label="$t('Sell.Charge.paid_amount')"></el-table-column>

            <el-table-column prop="oweAmt" :label="$t('Sell.OutstandingAmount')"></el-table-column>
            <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" width="100px"></el-table-column>
            <el-table-column prop="validity" :label="$t('Contract.validity_period')" width="100px"></el-table-column>
            <el-table-column prop="coachNickname" :label="$t('Course.coach')"></el-table-column>
            <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" width="100px" >
                <template slot-scope="{row}">
                    {{ row.contractSalesStaffNickname }}
                    <template v-if="!row.isTheSameCoach && row.clientCoachNickname">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" >
                                <div>与跟进教练不同</div>
                                <div>{{ $t('Common.follow_coach') }}：{{row.clientCoachNickname}}</div>
                            </div>
                            <span class="iconfont icon-fitness-point diff-icon"></span>
                        </el-tooltip>
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="clientMshpSalesNickname" :label="$t('Common.saler')" v-if="false"/>
            <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
        <pay-form
            ref="pay"
            :contract="'personal'"
            v-model="input"
            @fetchData="fetchData" />
        <!-- 修改合同开始时间 -->
        <modify-batch-time
            :total="pagination.total"
            :activeName="activeName"
            :filter="form"
            :contracts="contracts"
            :tableData="tableData"
            @fetchData="fetchData"
            :date="date"
            ref="batch" />
        <!-- 修改上课教练 -->
        <select-coach ref="selectCoach" @fetchData="fetchData" />
    </div>
</template>
<script>
import PayForm from '@/components/Dialog/Client/PayForm';
import ModifyBatchTime from '@/components/Dialog/Sell/ModifyBatchTime.vue';
import handleUser from '@/mixins/handleUser.js';
import SelectCoach from '@/components/Dialog/Sell/SelectCoach.vue';

export default {
    name: 'trainerContract',
    props: ['activeName', 'form', 'date', 'stores', 'contractNum'],
    components: {
        PayForm,
        SelectCoach,
        ModifyBatchTime,
    },
    mixins: [handleUser],
    data() {
        return {
            input: '',
            contracts: [],
            tableData: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeName(val) {
            if (val === 'personal') this.fetchData();
        },
        input(val) {
            if (val === 'update') this.flush();
        },
        contractNum(val) {
            this.fetchData(1);
        },
    },
    created() {
        if (this.activeName === 'personal')  this.fetchData();
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            if (this.contractNum) this.form.contractNum = this.contractNum;
            if (this.date) {
                this.form.createdAtStart = this.date[0];
                this.form.createdAtEnd = this.date[1];
            }
            API.get('contract/coach/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}个合同，
                购买总量${res.totalLesson}节，已上课${res.lessonConsumed}节，剩余${res.lessonBalance}节`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        flush(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('contract/coach/pages', {
                params: {
                    ...this.pagination,
                    statusCode: 1,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                console.log('totalLesson', res.totalLesson);
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}个合同，
                购买总量${res.totalLesson}节，已上课${res.lessonConsumed}节，剩余${res.lessonBalance}节`;
                this.$emit('input', msg);
            }).finally(() => {
                this.loading = false;
            });
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.tableData.toggleRowSelection(row);
                });
            } else {
                this.$refs.tableData.clearSelection();
            }
        },
        handleShow(row) {
            this.$router.push({
                name: 'Sell.Show',
                params: {
                    id: row.contractNum,
                    url: 'contract/coach',
                },
            });
        },
        handleSelectionChange(val) {
            this.contracts = val;
            this.$emit('headListen', this.contracts);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        validSelect() {
            if (this.contracts.length > 1) $ele.$message.warning(this.$t('Message.once_data'));
            else if (this.contracts.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
        pay() {
            if (this.validSelect()) this.$refs.pay.open(this.contracts[0].contractNum);
        },
        openBatch() {
            this.$refs.batch.open(this.contracts);
        },
        // 修改上课教练
        openCoach() {
            if (!this.contracts.length) $ele.$message.warning(this.$t('Message.choose_contract'));
            else if (!this.$$filterPermission('售卖-私教合同管理-修改上课教练')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
            else this.$refs.selectCoach.open(this.contracts);
        },
        // 查看原合同号
        goDetails(val) {
            this.$router.replace({query: {
                activeName: this.activeName,
                contractNum: val,
            }})
        },
    },
};
</script>
<style lang="scss">
.trainer-contract {
    .task-workers {
        color: #409EFF;
        cursor: pointer;
    }
    .task-status{
        color: #2a9546;
    }
    a:hover {
        color: #409EFF;
    }
    .del-status {
        color:#ce6969;
    }
    .diff-icon{
        background-color: orange !important;
        border-radius:25px;
        color:white;
    }
}
</style>
